<template>
    <div class="seo" v-if="display">
        <div class="container">
            <div class="form__wrapper">
                <label class="form__label" for="">
                    <span>Title</span>
                    <input type="text" v-model="meta.title">
                </label>
                <label class="form__label" for="">
                    <span>Keywords</span>
                    <input type="text" v-model="meta.keywords">
                </label>
                <label class="form__label" for="">
                    <span>Description</span>
                    <input type="text" v-model="meta.description">
                </label>
                <label class="form__label" for="">
                    <span>Canonical</span>
                    <input type="text" v-model="meta.canonical">
                </label>
                <div class="seo-edit-submit">
                    <button class="btn btn-big btn-green" @click="save()">
                        Speichern
                    </button>
                </div>

            </div>
            <button class="seo-edit-content btn btn-big btn-green" @click="toggleChange">
                <span v-if="!isEditMode">Edit</span>
                <span v-else>Cancel</span>
            </button>
        </div>
        <div v-if="currentTarget" class="modal-wrapper">
            <div class="cart-mobile">
                <span class="cart-header__btn" @click="close">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14 1.225L12.775 0L7 5.775L1.225 0L0 1.225L5.775 7L0 12.775L1.225 14L7 8.225L12.775 14L14 12.775L8.225 7L14 1.225Z"
                            fill="black"/>
                    </svg>
                </span>
                <h2 class="cart-header">
                    Edit
                </h2>
                <div class="modal-editor">
                    <trumbowyg v-model="currentTarget.content" :config="configs.basic" class="form-control" name="content"></trumbowyg>
                </div>
                <button class="seo-edit-save btn btn-big btn-green" @click="close()">
                    Save
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {seoUpdate, seoView} from "../api/seo";
import Trumbowyg from 'vue-trumbowyg';

$.trumbowyg.svgPath = '/dist/base/img/icons.svg';
export default {
    name: "SeoControl",
    data() {
        return {
            isShow: true,
            changeable: [],
            changeableNames: [],
            currentTarget: null,
            isEditMode: false,
            meta: {
                title: null,
                keywords: null,
                description: null,
                canonical: null,
            },
            htmlBlocks: {},
            uid: null,
            display: true,
            configs: {
                basic: {
                    autogrow: false
                },
                advanced: {
                    autogrow: true,
                    removeformatPasted: true,
                    // Adding color plugin button
                    btnsAdd: ['foreColor', 'backColor'],
                    // Limit toolbar buttons
                    btns: [
                        ['bold', 'italic'], ['formatting'], ['link'],
                        ['foreColor'], ['backColor'],
                    ]
                },
            },
        }
    },
    components: {
        Trumbowyg
    },
    async mounted() {
        this.meta.title = document.querySelector('title').text
        let uidMeta = document.querySelector('meta[name="page"]')
        if(!uidMeta){
            this.display = false
            return
        }
        this.uid = document.querySelector('meta[name="page"]').content
        let res = await seoView(this.uid);
        Object.keys(res.data.page.blocks).forEach(key => {
            this.changeable.push({name: res.data.page.blocks[key].name, content: res.data.page.blocks[key].content})
            this.changeableNames.push(res.data.page.blocks[key].name)
        })
        Object.keys(res.data.page.metaTags).forEach(key => {
            this.meta[res.data.page.metaTags[key].name] = res.data.page.metaTags[key].content
        })
        this.meta.route = res.data.page.route
    },

    methods: {
        toggleChange() {
            if (!this.isEditMode) {
                this.isEditMode = true
                window.addEventListener('mousemove', this.findChangeableElement)
            } else {
                this.isEditMode = false
                this.currentTarget = false
                window.removeEventListener('mousemove', this.findChangeableElement)
            }
        },
        setActive(item, content) {
            this.currentTarget = {item, content}
        },
        findChangeableElement(e) {
            let path = e.path
            if (path)
                path.forEach(item => {
                    let allowed = false
                    if(!item)
                        return
                    if(!item.dataset)
                        return
                    if (this.changeableNames.includes(item.dataset.name)) {
                        allowed = true
                    }

                    if (allowed) {
                        item.style.outline = '2px solid black'
                        item.style.outlineOffset = '5px'
                        item.style.cursor = 'pointer'
                        item.addEventListener('mouseout', () => {
                            item.style.outline = ''
                            item.style.outlineOffset = ''
                            item.style.cursor = ''
                        })
                        item.addEventListener('click', ()=>{
                            this.setActive(item.dataset.name, item.innerHTML)
                        })
                    }
                })
        },
        updateContent(){
            this.changeable.find(a => a.name.toLowerCase() === this.currentTarget.item.toLowerCase()).content = this.currentTarget.content
        },
        close() {
            this.changeable.find(a => a.name.toLowerCase() === this.currentTarget.item.toLowerCase()).content = this.currentTarget.content
            this.currentTarget = null
            this.save()
        },
        async save() {
            let data = new FormData()
            Object.keys(this.meta).forEach((item, idx) => {
                //if(this.meta[item]!==null){
                    data.append(`MetaTagForm[${idx}][name]`, item)
                    data.append(`MetaTagForm[${idx}][content]`, this.meta[item])
                //}
            })
            this.changeable.forEach((item, idx) => {
                data.append(`HtmlBlockForm[${idx}][name]`, item.name)
                data.append(`HtmlBlockForm[${idx}][content]`, item.content)
            })
            data.append('uid', this.uid)
            // data.append('PageForm[route]', window.location.pathname)
            data.append('PageForm[route]', this.meta.route)
            //data.append('PageForm[canonical]', `<link rel="canonical" href="/my-test-updated">`)
            await seoUpdate(data)
            this.currentTarget = null
            window.location.reload()
        },
    }
}
</script>

<style scoped lang="scss">
@import 'trumbowyg/dist/ui/trumbowyg.min.css';

.seo {
    background-color: #fafafa;
    padding-bottom: 20px;

    &-edit-content {
        position: fixed;
        bottom: 10px;
        right: 10px;
        z-index: 9999;
    }

    &-edit-save {
        margin-top: 70px;
    }

    .trumbowyg{
        text-align: right;
        margin-bottom: 30px;
        .trumbowyg-editor > * {
            color: #666!important;
        }
    }
    .trumbowyg-box .trumbowyg-editor{
        height:450px!important;
    }

    .form__wrapper {
        padding: 1rem 4rem 5rem;
    }

    .modal-editor {
        height: 400px;
    }
}

.form__label {
    padding: 20px 0 0 0;
    display: block;
    width: 100%;
    margin-bottom: 20px;

    span {
        display: block;
        line-height: 132%;
        text-align: left;
        font-size: 18px;
        color: #3d454d;
        margin: 0 0 6px 2px;
    }

    input {
        height: 48px;
        border: 1px solid #d3dde6;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 12px;
        width: 100%;
    }
}

.modal-wrapper {
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background: rgba(0, 0, 0, .5);
    z-index: 999;
    left: 0;
    top: 0;
    position: fixed;
    width: 100vw;
    height: 100vh;
    -webkit-transition: all .5s ease 0s;
    -o-transition: all .5s ease 0s;
    transition: all .5s ease 0s;
}

.cart-mobile {
    width: 85vw;
    height: 660px;
    padding: 20px 40px;
    display: block;
    position: fixed;
    top: 40%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 44px 0 0;
    background-color: #fff;
    -webkit-transition: all .5s ease 0s;
    -o-transition: all .5s ease 0s;
    transition: all .5s ease 0s;
    overflow: hidden;
    z-index: 10;
    border-radius: 12px;
    overflow: scroll;
    .cart-header__btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
}

.cart-header {
    margin-bottom: 30px;
    text-align: center;
}

textarea {
    //font-size: .8rem;
}

textarea {
    border: 1px solid #d3dde6;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 12px;
    height: 100%;
    width: 100%;
    overflow: auto;
    resize: none;
    margin-bottom: 10px;
}
</style>
